import React, { Component } from "react";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import Paper from "@material-ui/core/Paper";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Preview.css";
import { _PermittedContent } from "../../../_module/utils/PermittedContent";
import DownloadLink from "../../../util/downloader/DownloadLink";
import {
  Grid,
  Divider,
  Box,
  AppBar,
  Tabs,
  Tab,
  Chip,
  CircularProgress,
} from "@material-ui/core";
// import trackfields from "../../../_module/definition/trackFields";
import clsx from "clsx";
// import {
//   _mlPlaylists,
//   _mlPlaylistsMetadataConfig,
// } from "../../../_module/definition/MlPlaylists";
import { _PermittedSetting } from "../../../_module/utils/PermittedSetting";
// import {
//   _settingMetadataConditional,
//   _settingMetadataFieldsCommercial,
//   _settingMetadataFieldsCommissioned,
//   _settingMetadataFieldsDefault,
//   _settingMetadataFieldsLibrary,
// } from "../../../_module/definition/SettingMusicMetadata";
import TextElement from "../../../util/preview-element/TextElement";
import { loadRuntime } from "../../../redux/actions/ClearanceRuntimeActions";
import { __getTrackStatusByID } from "../../../_clearance/utils/utils";
import UserDisplay from "../../../util/UserDisplay";
import DateTimeElement from "../../../util/preview-element/DateTimeElement";
import { __updateCfStatus } from "../clearance-form/Utils";
import { Link } from "react-router-dom";
import moment from "moment";
import Columns from "../../ml-music-search/track/Columns";
import { ColumnTypes } from "../../../util/table-view/TableTypes";
import Moment from "react-moment";
import ClearanceButton from "../../../_clearance/components/wizardv2/ClearanceButton";
import genres from "../../../_module/definition/genre";
import { helpModules } from "../../ml-admin/help-admin/help-view/Const";
import HelpWrap from "../../ml-admin/help-admin/help-view/HelpWrap";
import { NumberDisplay, userDisplay } from "../../../util/CommonFunc";
import {
  cfHeaderFieldList,
  CFOrgStatusLabel,
  PageTableType,
} from "../../../redux/Types";
import { AuthSrc } from "./../../../util/AuthSrc";
import MetaDataPopOut from "../../../_module/component/metadata-popout/metadata-popout";
import GroupDisplay from "util/GroupDisplay";
import CliIcon from "images/artwork.png";
import PlayerRef from "modules/ml-player/PlayerRef/PlayerRef";
import { appConfig } from "App";
import PrsDataPreview from "util/PrsDataPreview";
import PrsPopup from "_module/component/prs-popup/prs-popup";
import {
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  prsSetHistory,
  CreatePrsTrack,
  CreatePrsManualMatchTrack,
  search
} from "../../../redux/actions/MlTrackLibraryActions";
import {
  updatePrsData
} from "../../../redux/actions/MlLicTrackActions";
import TrackMetadataGrid from "_module/component/track-metadata-grid/track-metadata-grid";
import { DurationDisplayText } from "util/DurationDisplay.js";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tabpanel-${index}`}
      {...other}>
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

class Preview extends Component {
  constructor() {
    super();
    this.state = {
      tabValue: 0,
    };
  }

  colsDef = null;
  colsDefAll = null;

  componentDidMount() {
    const {
      runtime: { loading, errors, runtime },
      loadRuntime,
    } = this.props;
    if (!loading && !runtime && !errors) {
      loadRuntime(null);
    }
  }

  generateColsDef(origin) {
    const {
      orgRuntime: {
        runtime: {
          _settingMetadataConditional: _settingMetadataConditional,
          _settingMetadataFieldsDefault: _settingMetadataFieldsDefault,
          _settingMetadataFieldsCommercial: _settingMetadataFieldsCommercial,
          _settingMetadataFieldsLibrary: _settingMetadataFieldsLibrary,
          _settingMetadataFieldsCommissioned:
          _settingMetadataFieldsCommissioned,
          _mlMetadata: _mlMetadata,
          _trackMetadataConfig: _trackMetadataConfig,
        },
      },
    } = this.props;
    this.colsDefAll = [];
    this.colsDef = [];

    const metaDataSetting = _PermittedContent(
      [_mlMetadata, _trackMetadataConfig],
      []
    ) || { setting: [] };
    this.colsDefAll = this.colsDef =
      _PermittedSetting(
        metaDataSetting.setting,
        _settingMetadataFieldsDefault
      ) || [];

    if (
      _PermittedSetting(metaDataSetting.setting, _settingMetadataConditional) ||
      false
    ) {
      if (origin.startsWith("library")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsLibrary
          ) || this.colsDefAll;
      } else if (origin.startsWith("commercial")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommercial
          ) || this.colsDefAll;
      } else if (origin.startsWith("commissioned")) {
        this.colsDef =
          _PermittedSetting(
            metaDataSetting.setting,
            _settingMetadataFieldsCommissioned
          ) || this.colsDefAll;
      }
    }
  }

  a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  renderMetadata = (id, i, classes, selectedItem, t, prop) => {
    const {
      orgRuntime,
      orgRuntime: {
        runtime: { _trackFields: trackFields },
      },
    } = this.props;

    let _selectedItem = selectedItem.trackDetails;
    _selectedItem = {
      ..._selectedItem,
      ...(_selectedItem?.skyMlId ? { id: _selectedItem?.skyMlId } : {}),
    };

    let column = Columns[id];
    let value =
      _selectedItem[id] && Array.isArray(_selectedItem[id])
        ? _selectedItem[id].join(", ")
        : _selectedItem[id];

    return prop.tag ? (
      <div key={i} className={classes.trackTags}>
        <label
          className={
            id === "title" ? classes.trackTabsLabelBold : classes.trackTabsLabel
          }
          title={t(`modules.${id}`)}>
          {t(`modules.${id}`)}
        </label>
        {_selectedItem[id] && Array.isArray(_selectedItem[id])
          ? _selectedItem[id].map((desc, i) => {
            return desc ? <Chip key={i} label={desc} /> : null;
          })
          : _selectedItem[id]
            ? _selectedItem[id]
            : t("libraryPreview.na")}
      </div>
    ) : (
      <div key={i} className={classes.muDetailWrap}>
        <div
          className={clsx(
            id === "trackTitle" ? classes.muLabelsBold : classes.muLabels,
            classes.muLabels
          )}
          title={t(`modules.${id}`)}>
          {t(`modules.${id}`)}
        </div>
        <div className={classes.muSeperator}> :</div>
        {id === trackFields.trackTitle.id ? (
          <div
            className={clsx(
              id === trackFields.trackTitle.id
                ? classes.muDetailsBold
                : classes.muDetails,
              classes.muDetails
            )}
            title={_selectedItem[id]}>
            <ClearanceButton
              label={
                <>
                  <span>{_selectedItem[id]}</span>
                </>
              }
              hideCount
              hideIcon
              disableRipple
              wrapperClass={"inlineWizardLink"}
              selectedItems={[_selectedItem.id]}
              items={[]}
              loadingRequired={true}
              fromCfId={selectedItem.clearanceFormId}
              fromCfBy={selectedItem.clearanceFormCreatedBy}
              orgRuntime={orgRuntime}
            />
          </div>
        ) : id === trackFields.duration.id ? (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={DurationDisplayText({ seconds: value }) || ""}>
            {DurationDisplayText({ seconds: value }) || ""}
          </div>
        )  : id === trackFields.org_sky_MCPS.id ||
                          id === trackFields.org_sky_PPL.id ? (
                          <div
                            className={clsx(
                              id === trackFields.prodName.id
                                ? classes.muDetailsBold
                                : classes.muDetails,
                              classes.muDetails
                            )}
                            title={value || ""}>
                            {/* {value == true ? (
                              "No"
                            ) : value == false &&
                              id === trackFields.org_sky_MCPS.id ? (
                              // <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                              <span className={classes.nonMCPSPPL}>Yes</span>
                            ) : value == false && id === trackFields.org_sky_PPL.id ? (
                              // <span className={classes.nonMCPSPPL}>Non-PPL</span>
                              <span className={classes.nonMCPSPPL}>Yes</span>
                            ) : (
                              ""
                            )} */}
                         {value == true ? (
                              "Yes"
                            ) : value == false &&
                              id === trackFields.org_sky_MCPS.id ? (
                              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                              // <span className={classes.nonMCPSPPL}>Yes</span>
                            ) : value == false && id === trackFields.org_sky_PPL.id ? (
                              <span className={classes.nonMCPSPPL}>Non-PPL</span>
                              // <span className={classes.nonMCPSPPL}>Yes</span>
                            ) : (
                              ""
                            )}
                          </div>
                        )  : id === trackFields.org_sky_prodIsMCPSBlanket.id ||
                          id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                          <div
                            className={clsx(
                              id === trackFields.prodName.id
                                ? classes.muDetailsBold
                                : classes.muDetails,
                              classes.muDetails
                            )}
                            title={value || ""}>
                            {value == true ? (
                              ""
                            ) : value == false &&
                              id === trackFields.org_sky_prodIsMCPSBlanket.id ? (
                              <span className={classes.nonMCPSPPL}>Non-MCPS</span>
                            ) : value == false && id === trackFields.org_sky_prodIsPPLBlanket.id ? (
                              <span className={classes.nonMCPSPPL}>Non-PPL</span>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
          <div
            className={clsx(
              id === "title" ? classes.muDetailsBold : classes.muDetails,
              classes.muDetails
            )}
            title={
              column?.type === ColumnTypes.datetime ||
                column?.type === ColumnTypes.date
                ? null
                : id === trackFields.musicOrigin.id
                  ? t(`modules.originLables.${value}`)
                  : value || ""
            }>
            {column?.type === ColumnTypes.datetime ? (
              value ? (
                <Moment
                  format="DD/MM/YYYY h:mm:ss A"
                  titleFormat="DD/MM/YYYY h:mm:ss A"
                  withTitle>
                  {value}
                </Moment>
              ) : null
            ) : column?.type === ColumnTypes.date ? (
              value ? (
                <Moment format="DD/MM/YYYY" titleFormat="DD/MM/YYYY" withTitle>
                  {value}
                </Moment>
              ) : null
            ) : id === trackFields.musicOrigin.id ? (
              t(`modules.originLables.${value}`)
            ) : (
              value || ""
            )}
          </div>
        )}
      </div>
    );
  };

  getIpsText = (ipsArray) => {
    try {
      if (Array.isArray(ipsArray)) {
        return ipsArray
          ?.filter((r) => r?.fullName)
          .map((r) => r?.fullName)
          ?.join(", ");
      } else {
        return null;
      }
    } catch {
      return null;
    }
  };

  renderAdminNotes = (selectedItem, classes, t) => {
    return (
      <>
        <div className={classes.muDetailWrap}>
          <div
            title={`${JSON.parse(appConfig.ORG)?.lbl} Admin Notes`}
            className={classes.muLabels}>{`${JSON.parse(appConfig.ORG)?.lbl
              } Admin Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcAdminNotes || ""}>
            {selectedItem?.bbcAdminNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div
            title={`${JSON.parse(appConfig.ORG)?.lbl} Librarian Notes`}
            className={classes.muLabels}>{`${JSON.parse(appConfig.ORG)?.lbl
              } Librarian Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLibrarianNotes || ""}>
            {selectedItem?.bbcLibrarianNotes || ""}
          </div>
        </div>
        <div className={classes.muDetailWrap}>
          <div
            title={`${JSON.parse(appConfig.ORG)?.lbl} Licence Notes`}
            className={classes.muLabels}>{`${JSON.parse(appConfig.ORG)?.lbl
              } Licence Notes`}</div>
          <div className={classes.muSeperator}> :</div>
          <div
            className={classes.muDetails}
            title={selectedItem?.bbcLicenceNotes || ""}>
            {selectedItem?.bbcLicenceNotes || ""}
          </div>
        </div>
      </>
    );
  };

  getCfHeaderFieldValue = (field, value) => {
    const {
      runtime: { runtime },
    } = this.props;

    let val = value;
    let headerFields =
      runtime && runtime._config && runtime._config.CF_HEADER_FIELD_LIST
        ? runtime._config.CF_HEADER_FIELD_LIST
        : [];
    let index = null;
    switch (field) {
      case "clearanceFormClearanceFormType":
        index = headerFields.findIndex((e) => e.id == "clearanceFormType");
        if (index != -1) {
          val =
            headerFields[index].options?.find((i) => i.value == value)?.label ||
            val;
        }
        return val;
      case "clearanceFormProducerType":
        index = headerFields.findIndex((e) => e.id == "producerType");
        if (index != -1) {
          val =
            headerFields[index].options?.find((i) => i.value == value)?.label ||
            val;
        }
        return val;
      case "clearanceFormInputGroup":
        index = headerFields.findIndex((e) => e.id == "inputGroup");
        if (index != -1) {
          val =
            headerFields[index].options?.find((i) => i.value == value)?.label ||
            val;
        }
        return val;
      case "clearanceFormDepartment":
        index = headerFields.findIndex((e) => e.id == "department");
        if (index != -1) {
          val =
            headerFields[index].options?.find((i) => i.value == value)?.label ||
            val;
        }
        return val;
      case "clearanceFormChannel":
        index = headerFields.findIndex((e) => e.id == "channel");
        if (index != -1) {
          val =
            headerFields[index].options?.find((i) => i.value == value)?.label ||
            val;
        }
        return val;
      case "clearanceFormProductionCompany":
        index = headerFields.findIndex((e) => e.id == "productionCompany");
        if (index != -1) {
          val =
            headerFields[index].options?.find((i) => i.value == value)?.label ||
            val;
        }
        return val;
      case "clearanceFormProductionCompanyContact":
        index = headerFields.findIndex(
          (e) => e.id == "productionCompanyContact"
        );
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormSeriesTitle":
        index = headerFields.findIndex((e) => e.id == "seriesTitle");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormPromotionId":
        index = headerFields.findIndex((e) => e.id == "promotionId");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormPromotionTitle":
        index = headerFields.findIndex((e) => e.id == "programmeTitle");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormProgrammeTitle":
        index = headerFields.findIndex((e) => e.id == "programmeTitle");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormEpisodeTitle":
        index = headerFields.findIndex((e) => e.id == "episodeTitle");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormProdNumber":
        index = headerFields.findIndex((e) => e.id == "prodNumber");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormProductionName":
        index = headerFields.findIndex((e) => e.id == "productionName");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormContractNumber":
        index = headerFields.findIndex((e) => e.id == "contractNumber");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormEpisodeName":
        index = headerFields.findIndex((e) => e.id == "episodeTitle");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormEpisodeNumber":
        index = headerFields.findIndex((e) => e.id == "episodeNumber");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormDeliveryDate":
        index = headerFields.findIndex((e) => e.id == "deliveryDate");
        if (index != -1 && headerFields[index].type == "text") {
          val = val;
        }
        return val;
      case "clearanceFormTxDates":
        index = headerFields.findIndex((e) => e.id == "txDates");
        if (index != -1 && value) {
          val = value.join(" / ");
        }
        return val;
      case "clearanceFormUserGroup":
        index = headerFields.findIndex((e) => e.id == "userGroup");
        if (index != -1 && headerFields[index].type == "userGroup") {
          val = <GroupDisplay groupId={val} />;
        }
        return val;
      default:
        return val;
    }
    return val;
  };

  render() {
    const {
      classes,
      data: { selectedItem },
      runtime: { runtime },
      orgRuntime: {
        runtime: {
          _trackFields: trackfields,
          _mlMetadata: _mlMetadata,
          _canSeeAdminNotes: _canSeeAdminNotes,
          _extendedTrackPreviewMetadata,
        },
      },
      item,
      trackLibraryData: {
        PRSHistoryLoading,
      },
      prsTrackUnlink,
      prsHistorySearch,
      prsMechanicalOverride,
      prsSetHistory,
      CreatePrsTrack,
      updatePrsData,
      CreatePrsManualMatchTrack,
      search,
    } = this.props;

    let _selectedItem;
    if (this.props?.isPopOut) {
      _selectedItem = item;
    } else {
      _selectedItem = selectedItem.trackDetails;
    }
    let _status = {};

    if (_selectedItem && _selectedItem.id) {
      this.generateColsDef(
        (_selectedItem[trackfields.musicOrigin.id] || "").toLowerCase()
      );

      // _status = {
      //   name: selectedItem.clearancestatusName,
      //   color: selectedItem.clearancestatusColor,
      //   id: selectedItem.clearancestatus,
      // };
      _status = runtime?._statuses.filter(
        (d) => d.id == selectedItem.clearancestatus
      )[0] || {
        name: selectedItem.clearancestatusName,
        color: selectedItem.clearancestatusColor,
        id: selectedItem.clearancestatus,
      };
    }

    const canViewAdminNotes = _PermittedContent(
      [_mlMetadata, _canSeeAdminNotes],
      []
    )
      ? true
      : false;

    return (
      <Translation>
        {(t, { i18n }) => (
          <Paper className={classes.sideBar} role="contentinfo">
            {_selectedItem && _selectedItem.id ? (
              <>
                {!this.props?.isPopOut && (
                  <>
                    <Paper className={classes.disFlex}>
                      <h2 className={classes.muTitle}>
                        {_selectedItem[trackfields.trackTitle.id] ||
                          t("libraryPreview.na")}
                        <span className={classes.muSubTitle}>
                          {/* {this.getIpsText(
                            _selectedItem[trackfields.performer.id]
                          ) || t("libraryPreview.na")} */}
                          {(_selectedItem[trackfields.performer.id] &&
                            Array.isArray(_selectedItem[trackfields.performer.id])
                            ? _selectedItem[trackfields.performer.id].join(", ")
                            : _selectedItem[trackfields.performer.id]) ||
                            t("libraryPreview.na")}
                        </span>
                      </h2>
                      <HelpWrap config={helpModules.CTPWH} />
                      <DownloadLink
                        track={_selectedItem}
                        cfId={{
                          ..._selectedItem.trackDetails,
                          ...(_selectedItem?.trackDetails?.skyMlId
                            ? { id: _selectedItem?.trackDetails?.skyMlId }
                            : {}),
                        }}
                        cfTrackSequenceId={_selectedItem?.trackDetails?.id}
                      />
                    </Paper>
                    <div style={{ display: "flex" }}>
                      <Paper>

                        <Box
                          className={classes.artworkHolder}
                          tabIndex="-1"
                          p={1}>
                          <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justify="center">
                            {_selectedItem[trackfields.prodArtworkUrl.id] ? (
                              <img
                                style={{ height: 240, width: 240 }}
                                src={AuthSrc(
                                  _selectedItem[trackfields.prodArtworkUrl.id]
                                )}
                                alt={
                                  _selectedItem[trackfields.trackTitle.id] || ""
                                }
                              />
                            ) : (
                              <Grid
                                container
                                direction="column"
                                alignItems="center"
                                justify="center">
                                {" "}
                                <img
                                  style={{ width: 250 }}
                                  src={CliIcon}
                                  alt="Sky Music"
                                />
                                {/* <MusicNoteIcon style={{ fontSize: 60 }} /> */}
                              </Grid>
                            )}
                          </Grid>

                          <PlayerRef
                            className={classes.playTrackButton}
                            key={_selectedItem?.id}
                            aria-label="Play"
                            item={{
                              ..._selectedItem,
                              ...(_selectedItem?.skyMlId
                                ? { id: _selectedItem?.skyMlId }
                                : {}),
                            }}
                            popoutFor={PageTableType.CLEARANCE_FORM_TRACKS}
                          />
                        </Box>
                      </Paper>
                      <div className={classes.popOutBlock}>
                        {
                          <MetaDataPopOut
                            popoutFor={PageTableType.CLEARANCE_TRACKS}
                            data={selectedItem}
                          />
                        }
                        {
                          <PrsPopup
                            prsTrackUnlink={prsTrackUnlink}
                            prsHistorySearch={prsHistorySearch}
                            prsmechanicaloverride={prsMechanicalOverride}
                            PRSHistoryLoading={PRSHistoryLoading}
                            // popoutFor={PageTableType.SEARCH_TRACKS}
                            mbTrackData={selectedItem.trackDetails}
                            prsTrackData={selectedItem?.trackDetails?.prsTrack}
                            updatePrsData={updatePrsData}
                            // trackSearch={() => {
                            //   search(query);
                            // }}
                            prsSetHistory={prsSetHistory}
                            CreatePrsTrack={CreatePrsTrack}
                            popoutFor={PageTableType.CLEARANCE_TRACKS}
                            // focusItem={focusItem}
                            mlsearch={search}
                            CreatePrsManualMatchTrack={CreatePrsManualMatchTrack}
                          />
                        }
                      </div>


                    </div>
                  </>
                )}

                <AppBar className={classes.trackTabsHeader} position="static">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChange}
                    scrollButtons="auto"
                    variant="scrollable">
                    <Tab label="Clearance" {...this.a11yProps(1)} />
                    <Tab label="Metadata" {...this.a11yProps(0)} />
                    <Tab label="PRS" {...this.a11yProps(2)} />
                    <Tab label="Notes" {...this.a11yProps(3)} />
                    {/* <Tab label="All" {...this.a11yProps(3)} /> */}
                  </Tabs>
                </AppBar>

                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={1}>
                    {!this.props?.isPopOut? 
                     <Paper className={classes.paperwrap}>
                     <div className={clsx(classes.muListWrap, "popupWindow")}>
                       {this.colsDefAll?.map((id, i) => {
                         const prop = trackfields[id] || {};
                         return this.renderMetadata(
                           id,
                           i,
                           classes,
                           selectedItem,
                           t,
                           prop
                         );
                       })}
                       {canViewAdminNotes &&
                         this.renderAdminNotes(selectedItem, classes, t)}
                     </div>
                   </Paper>
                   :
                   (<TrackMetadataGrid data={item} classes={classes} />)
                    }
                 
                </TabPanel>
                <TabPanel
                className={classes.trackTabs}
                value={this.state.tabValue}
                index={0}>
                <Paper className={classes.paperwrap}>
                  <div className={clsx(classes.muListWrap, "popupWindow")}>
                    <TextElement
                      label="ID"
                      classes={classes}
                      data={selectedItem.clearanceFormId}
                    />
                    <TextElement
                      label="PRODUCTION NAME/SERIES"
                      classes={classes}
                      showCustomTitle={true}
                      customTitle={selectedItem.clearanceFormName}
                      data={
                        selectedItem.clearanceFormName ? (
                          <Link
                            aria-label={`Open to clearance form for ${selectedItem.clearanceFormName}`}
                            style={{ textDecoration: "none", color: "#fff" }}
                            key={selectedItem.clearanceFormId}
                            to={`/mllicensingforms/${selectedItem.clearanceFormId}/${selectedItem.trackDetails.id}`}>
                            <strong class="tablesLink">
                              {selectedItem.clearanceFormName}
                            </strong>
                          </Link>
                        ) : (
                          t("playlistPreview.na")
                        )
                      }
                    />

                    {/* <TextElement
                      label="CF Workflow Status"
                      classes={classes}
                      showCustomTitle
                      customTitle = {CFOrgStatusLabel[selectedItem?.clearanceFormWorkflowStatus] ? CFOrgStatusLabel[selectedItem?.clearanceFormWorkflowStatus].label : ""}
                      data= { CFOrgStatusLabel[selectedItem?.clearanceFormWorkflowStatus] ? <span className={classes.cfStatus} > <span style={{
                        backgroundColor: CFOrgStatusLabel[selectedItem.clearanceFormWorkflowStatus].color,
                        width: "17px",
                        height: "17px",
                        borderRadius: "50%",                             
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginRight: "5px",
                      }}></span> {CFOrgStatusLabel[selectedItem.clearanceFormWorkflowStatus].label } </span> : <span className={classes.cfStatus}></span>}
                    
                    /> */}

                    {/* <TextElement
                        label="CF Ref No"
                        classes={classes}
                        data={selectedItem.clearanceFormRefNo}
                      
                    /> */}

                    {/* <TextElement
                      label="CF Genre"
                      classes={classes}
                      data={Object.keys(genres).map(key=>genres[key]).filter(d=>d.id == selectedItem.clearanceFormGenre)[0]?.label || "-"}
                    /> */}

                    {/* <TextElement
                      label="CF Music Rights Contact"
                      classes={classes}
                      data={userDisplay(selectedItem.clearanceFormAllocatedUser)}
                    /> */}

                    {/* <TextElement
                      label="DEADLINE DATE"
                      classes={classes}
                      data={selectedItem.clearanceFormDeadline?new Date(selectedItem.clearanceFormDeadline).toLocaleDateString("en-UK"):''}
                    /> */}

                    {/* <TextElement
                      label="CF Synopsis"
                      classes={classes}
                      data={selectedItem.clearanceFormSynopsis}
                      
                    /> */}

                    <TextElement
                      label="Status"
                      classes={classes}
                      data={
                        _status.name ? (
                          <span
                            className={classes.clearanceTrafficContainer}
                            style={{
                              color: _status.color,
                            }}>
                            {_status.color != 0 && (
                              <span
                                style={{
                                  background: _status.color,
                                }}
                                className={
                                  classes.clearanceTrafficLight
                                }></span>
                            )}
                            {_status.name}
                          </span>
                        ) : (
                          "NA"
                        )
                      }
                      customTitle={_status.name}
                      showCustomTitle={true}
                    />

                    <TextElement
                      label="CF Form Type"
                      classes={classes}
                      // data={selectedItem.clearanceFormClearanceFormType}
                      data={this.getCfHeaderFieldValue(
                        "clearanceFormClearanceFormType",
                        selectedItem.clearanceFormClearanceFormType
                      )}
                    />

                    <TextElement
                      label="CF Producer Type"
                      classes={classes}
                      // data={selectedItem.clearanceFormProducerType}
                      data={this.getCfHeaderFieldValue(
                        "clearanceFormProducerType",
                        selectedItem.clearanceFormProducerType
                      )}
                    />
                    <TextElement
                      label="CF User Group"
                      classes={classes}
                      // data={selectedItem.clearanceFormInputGroup}
                      data={this.getCfHeaderFieldValue(
                        "clearanceFormUserGroup",
                        selectedItem.clearanceFormUserGroup
                      )}
                    />
                    {/* <TextElement
                      label="CF Input Group"
                      classes={classes}
                      // data={selectedItem.clearanceFormInputGroup}
                      data={this.getCfHeaderFieldValue("clearanceFormInputGroup", selectedItem.clearanceFormInputGroup)}
                    />
                    <TextElement
                      label="CF Department"
                      classes={classes}
                      // data={selectedItem.clearanceFormDepartment}
                      data={this.getCfHeaderFieldValue("clearanceFormDepartment", selectedItem.clearanceFormDepartment)}
                    /> */}
                    <TextElement
                      label="CF Channel"
                      classes={classes}
                      // data={selectedItem.clearanceFormChannel}
                      data={this.getCfHeaderFieldValue(
                        "clearanceFormChannel",
                        selectedItem.clearanceFormChannel
                      )}
                    />
                    <TextElement
                      label="CF Channel Name"
                      classes={classes}
                      data={selectedItem.clearanceFormChannelName}
                    // data={this.getCfHeaderFieldValue("clearanceFormChannelName", selectedItem.clearanceFormChannelName)}
                    />
                    <TextElement
                      label="CF Production Company"
                      classes={classes}
                      data={selectedItem.clearanceFormProductionCompany}
                    // data={this.getCfHeaderFieldValue("clearanceFormProductionCompany", selectedItem.clearanceFormProductionCompany)}
                    />
                    <TextElement
                      label="CF Production Company Contact"
                      classes={classes}
                      data={
                        selectedItem.clearanceFormProductionCompanyContact
                      }
                    // data={this.getCfHeaderFieldValue("clearanceFormProductionCompanyContact", selectedItem.clearanceFormProductionCompanyContact)}
                    />
                    <TextElement
                      label="CF Series Title"
                      classes={classes}
                      data={selectedItem.clearanceFormSeriesTitle}
                    // data={this.getCfHeaderFieldValue("clearanceFormSeriesTitle", selectedItem.clearanceFormSeriesTitle)}
                    />
                    <TextElement
                      label="CF Promotion ID"
                      classes={classes}
                      data={selectedItem.clearanceFormPromotionId}
                    // data={this.getCfHeaderFieldValue("clearanceFormPromotionId", selectedItem.clearanceFormPromotionId)}
                    />
                    <TextElement
                      label="CF Promotion Title"
                      classes={classes}
                      data={selectedItem.clearanceFormPromotionTitle}
                    // data={this.getCfHeaderFieldValue("clearanceFormPromotionTitle", selectedItem.clearanceFormPromotionTitle)}
                    />
                    <TextElement
                      label="CF Programme Title"
                      classes={classes}
                      data={selectedItem.clearanceFormProgrammeTitle}
                    // data={this.getCfHeaderFieldValue("clearanceFormProgrammeTitle", selectedItem.clearanceFormProgrammeTitle)}
                    />
                    <TextElement
                      label="CF Episode Title"
                      classes={classes}
                      data={selectedItem.clearanceFormEpisodeTitle}
                    // data={this.getCfHeaderFieldValue("clearanceFormEpisodeTitle", selectedItem.clearanceFormEpisodeTitle)}
                    />
                    <TextElement
                      label="CF Prod Number"
                      classes={classes}
                      data={selectedItem.clearanceFormProdNumber}
                    // data={this.getCfHeaderFieldValue("clearanceFormProdNumber", selectedItem.clearanceFormProdNumber)}
                    />
                    <TextElement
                      label="CF Production Name"
                      classes={classes}
                      data={selectedItem.clearanceFormProductionName}
                    // data={this.getCfHeaderFieldValue("clearanceFormProductionName", selectedItem.clearanceFormProductionName)}
                    />
                    <TextElement
                      label="CF Contract Number"
                      classes={classes}
                      data={selectedItem.clearanceFormContractNumber}
                    // data={this.getCfHeaderFieldValue("clearanceFormContractNumber", selectedItem.clearanceFormContractNumber)}
                    />
                    <TextElement
                      label="CF Episode Name"
                      classes={classes}
                      data={selectedItem.clearanceFormEpisodeName}
                    // data={this.getCfHeaderFieldValue("clearanceFormEpisodeName", selectedItem.clearanceFormEpisodeName)}
                    />
                    <TextElement
                      label="CF Episode Number"
                      classes={classes}
                      data={selectedItem.clearanceFormEpisodeNumber}
                    // data={this.getCfHeaderFieldValue("clearanceFormEpisodeNumber", selectedItem.clearanceFormEpisodeNumber)}
                    />
                    <TextElement
                      label="CF Delivery Date"
                      classes={classes}
                      data={selectedItem.clearanceFormDeliveryDate}
                    // data={this.getCfHeaderFieldValue("clearanceFormDeliveryDate", selectedItem.clearanceFormDeliveryDate)}
                    />
                    <TextElement
                      label="CF TX Dates"
                      classes={classes}
                      // data={selectedItem.clearanceFormTxDates}
                      data={this.getCfHeaderFieldValue(
                        "clearanceFormTxDates",
                        selectedItem.clearanceFormTxDates
                      )}
                    />

                    {selectedItem.adminOverridden ? (
                      <>
                        <TextElement
                          label="Overridden by"
                          classes={classes}
                          data={
                            <UserDisplay userId={selectedItem.createdBy} />
                          }
                        />

                        <TextElement
                          label="With Notes"
                          classes={classes}
                          data={
                            selectedItem.adminOverriddenWithNotes ||
                            t("libraryPreview.na")
                          }
                        />
                      </>
                    ) : (
                      ""
                    )}

                    <DateTimeElement
                      label="Created"
                      classes={classes}
                      data={selectedItem.createdAt}
                    />

                    <TextElement
                      label="Created By"
                      classes={classes}
                      data={userDisplay(selectedItem.createdBy)}
                    />

                    <DateTimeElement
                      label="Updated"
                      classes={classes}
                      data={selectedItem.updatedAt}
                    />

                    <TextElement
                      label="Updated By"
                      classes={classes}
                      data={userDisplay(selectedItem.updatedBy)}
                    />
                    {runtime?._config?.CF_TRACK_ORG_STATUS?.LICENSED &&
                      +selectedItem.clearancestatus ===
                      +runtime?._config?.CF_TRACK_ORG_STATUS.LICENSED && (
                        <>
                          {selectedItem?.licensingInfoList &&
                            selectedItem?.licensingInfoList?.length > 0 && (
                              <>
                                <TextElement
                                  label="Budget / Fee"
                                  classes={classes}
                                  data={
                                    <>
                                      {selectedItem.licensingInfoList.map(
                                        (d) => {
                                          return (
                                            <>
                                              <div class="flexContainer grayContainer">
                                                <div class="licName">
                                                  {d.licensingName}{" "}
                                                  <span>
                                                    {
                                                      (
                                                        runtime?._config
                                                          ?.CF_LICENSING_TYPE_LIST ||
                                                        []
                                                      ).find(
                                                        (k) =>
                                                          k.value ===
                                                          d.licensingType
                                                      )?.label
                                                    }
                                                  </span>
                                                </div>

                                                <div class="licFee">
                                                  {" "}
                                                  <NumberDisplay
                                                    value={d.budget}
                                                  />{" "}
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }
                                      )}
                                    </>
                                  }
                                />
                              </>
                            )}
                          <TextElement
                            label="Notes (License)"
                            classes={classes}
                            data={selectedItem.licensingInfoNotes || "N/A"}
                          />
                          <TextElement
                            label="MCPS"
                            classes={classes}
                            data={
                              selectedItem.societyIndicatorMcps
                                ? (
                                  runtime?._config?.CF_SI_MCPS_TYPE_LIST ||
                                  []
                                ).find(
                                  (k) =>
                                    k.value ===
                                    +selectedItem.societyIndicatorMcps
                                )?.label
                                : "N/A"
                            }
                          />
                          <TextElement
                            label="PPL"
                            classes={classes}
                            data={
                              selectedItem.societyIndicatorPpl
                                ? (
                                  runtime?._config?.CF_SI_PPL_TYPE_LIST ||
                                  []
                                ).find(
                                  (k) =>
                                    k.value ===
                                    +selectedItem.societyIndicatorPpl
                                )?.label
                                : "N/A"
                            }
                          />
                        </>
                      )}
                  </div>
                </Paper>
              </TabPanel>
              
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={2}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      <PrsDataPreview
                        classes={classes}
                        selectedItem={selectedItem?.trackDetails}
                      />
                    </div>
                  </Paper>
                </TabPanel>
                <TabPanel
                  className={classes.trackTabs}
                  value={this.state.tabValue}
                  index={3}>
                  <Paper className={classes.paperwrap}>
                    <div className={clsx(classes.muListWrap, "popupWindow")}>
                      <TextElement
                        label="Form Notes"
                        classes={classes}
                        data={selectedItem.clearanceFormNotes}
                      />

                      <TextElement
                        label="Track Notes"
                        classes={classes}
                        data={
                          selectedItem.trackNotes &&
                            Array.isArray(selectedItem.trackNotes)
                            ? selectedItem.trackNotes.map((v, i) => {
                              return (
                                <div>
                                  {i + 1} - {v}
                                </div>
                              );
                            })
                            : selectedItem.trackNotes || t("libraryPreview.na")
                        }
                        showCustomTitle
                        customTitle={
                          selectedItem.trackNotes &&
                            Array.isArray(selectedItem.trackNotes)
                            ? selectedItem.trackNotes.map((v, i) => {
                              return `${i + 1} - ${v}`;
                            })
                            : selectedItem.trackNotes || t("libraryPreview.na")
                        }
                      />
                    </div>
                  </Paper>
                </TabPanel>
              </>
            ) : (
              <div className={classes.noData}>
                {/* <MusicNoteIcon style={{ fontSize: 60, marginBottom: 20 }} /> */}
                <img
                  className={"emptyArtwork"}
                  style={{ width: 120 }}
                  src={CliIcon}
                  alt="Sky Music"
                />

                {/* {t("libraryPreview.noPreview")} */}
              </div>
            )}
          </Paper>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mllictrack,
  trackLibraryData: state.mltracklibrary,
  runtime: state.clearanceRuntime,
  allUsers: state.inbox.allUsers,
  orgRuntime: state.orgRuntime,
});

export default connect(mapStateToProps, {
  loadRuntime,
  prsTrackUnlink,
  prsHistorySearch,
  prsMechanicalOverride,
  prsSetHistory,
  CreatePrsTrack,
  updatePrsData,
  CreatePrsManualMatchTrack,
  search
})(
  withStyles(styles)(Preview)
);
